import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Platform, IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SplashScreen } from '@capacitor/splash-screen';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
  faAngleDown,
  faArchive,
  faBars,
  faBookReader,
  faCircle,
  faClipboard,
  faClone,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCogs,
  faCommentDots,
  faDatabase,
  faDotCircle,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFile,
  faGripLines,
  faHandPointer,
  faICursor,
  faImage,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faPalette,
  faPencilAlt,
  faPlus,
  faPlusSquare,
  faSave,
  faSearch,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faTachometerAlt,
  faTerminal,
  faTimes,
  faToggleOn,
  faTrashAlt,
  faUserCheck,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet, FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly platform: Platform = inject(Platform);

  constructor() {
    const library: FaIconLibrary = inject(FaIconLibrary);

    // All the Font Awesome icons we use throughout the application.
    // Make sure these are ordered by type (brands/solid/regular) first and
    // per type alphabetically, for easier reading/finding.
    library.addIcons(
      // Solid
      faAngleDown,
      faArchive,
      faBookReader,
      faCircle,
      faClipboard,
      faCloudUploadAlt,
      faClone,
      faCogs,
      faCommentDots,
      faCloudDownloadAlt,
      faDatabase,
      faDotCircle,
      faDownload,
      faEdit,
      faEye,
      faEnvelope,
      faExclamationTriangle,
      faFile,
      faGripLines,
      faHandPointer,
      faLayerGroup,
      faLightbulb,
      faLink,
      faList,
      faICursor,
      faImage,
      faInfoCircle,
      faPalette,
      faPencilAlt,
      faPlus,
      faPlusSquare,
      faUsers,
      faSave,
      faSearch,
      faSignOutAlt,
      faSlidersH,
      faStar,
      faTachometerAlt,
      faTerminal,
      faTimes,
      faTrashAlt,
      faToggleOn,
      faUserCheck,
      faEdit,
      faBars,
    );
  }

  public ngOnInit(): void {
    this.initializeApp();
  }

  public initializeApp(): void {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        SplashScreen.hide();
      }
    });
  }
}
